export const CAREER_SETTING = {
                                    texts:{
                                                modal:{
                                                            message:'If you reset the career page all the changes will be lost and reset to default careers page. Are you sure to proceed?',
                                                            button_1: 'Cancel',
                                                            button_2: 'Reset'
                                                      },
                                                
                                          }
                              }
